import { gql } from '@apollo/client';

export const SAVE_EXIT_STRATEGY_LEVELS = gql`
  mutation SaveExitStrategyLevels($portfolioId: ID!, $tokenId: ID!, $levels: [ExitLevelInput!]!, $templateId: ID, $params: ExitStrategyParamsInput) {
    saveExitStrategyLevels(portfolioId: $portfolioId, tokenId: $tokenId, levels: $levels, templateId: $templateId, params: $params) {
      success
      error
      exitStrategy {
        levels {
          id
          amount
          price
          status
          warning
        }
        sellAmount
        proceeds
        cost
        templateId
        templateName
        isModified
        templateOutOfSync
        params {
          targetMultiple
          baseSource
          exitLevelsCount
          exitLevelsSpread
          takeInitialsEnabled
          takeInitialsMultiple
          hodlEnabled
          hodlPercentage
          advancedDistributionEnabled
          distributionCurve
          distributionFocus
          distributionIntensity
        }
      }
    }
  }
`;

export const SET_EXIT_LEVEL_STATUS = gql`
  mutation SetExitLevelStatus($levelId: ID!, $status: ExitLevelStatus!) {
    setExitLevelStatus(levelId: $levelId, status: $status)
  }
`;

export const EDIT_EXIT_LEVEL = gql`
  mutation EditExitLevel($levelId: ID!, $updates: EditExitLevelInput!) {
    editExitLevel(levelId: $levelId, updates: $updates) {
      success
      error
      exitStrategy {
        levels {
          id
          amount
          price
          status
          warning
        }
        sellAmount
        proceeds
        cost
        templateId
        templateName
        isModified
        templateOutOfSync
      }
    }
  }
`;

export const REMOVE_EXIT_LEVEL = gql`
  mutation RemoveExitLevel($levelId: ID!) {
    removeExitLevel(levelId: $levelId)
  }
`;

export const ADD_EXIT_LEVEL = gql`
  mutation AddExitLevel($portfolioId: ID!, $tokenId: ID!, $price: String!, $amount: String!) {
    addExitLevel(portfolioId: $portfolioId, tokenId: $tokenId, price: $price, amount: $amount) {
      success
      error
      exitStrategy {
        levels {
          id
          amount
          price
          status
          warning
        }
        sellAmount
        proceeds
        cost
        templateId
        templateName
        isModified
        templateOutOfSync
      }
    }
  }
`;

export const REMOVE_EXIT_STRATEGY = gql`
  mutation RemoveExitStrategy($portfolioId: ID!, $tokenId: ID!) {
    removeExitStrategy(portfolioId: $portfolioId, tokenId: $tokenId) {
      success
      error
    }
  }
`; 